console.log("TEST.JS LOADED");

/* ==========================================
   CAT DATA
========================================== */

const cats = new Map();
/* ==========================================
   UI HELPERS
========================================== */

function disableTreatButtons() {

  document.querySelectorAll(".treat-btn").forEach(button => {

    button.disabled = true;
    button.classList.add("treat-disabled");
    button.textContent = "Come Back Tomorrow";

  });

}

function showSuccessMessage(card, message) {

  const success = card.querySelector(".success-message");

  if (!success) return;

  success.textContent = message;
  success.style.opacity = "1";

  setTimeout(() => {

    success.style.opacity = "0";

  }, 2500);

}

/* ==========================================
   LOAD PAGE
========================================== */

document.addEventListener("DOMContentLoaded", async () => {

  const cards = document.querySelectorAll(".treat-card");

  if (!cards.length) return;

  // ----------------------------------
  // Load all cats
  // ----------------------------------

  const { data: catRows, error } = await window.supabaseClient
    .from("Cats")
    .select("*");

  if (error) {

    console.error(error);
    return;

  }

  catRows.forEach(cat => {

    cats.set(cat.name, cat);

  });

  // ----------------------------------
  // Build every card
  // ----------------------------------

  cards.forEach(card => {

    const catName = card.dataset.catName;

    const cat = cats.get(catName);

    if (!cat) return;

    card.dataset.catId = cat.id;

    const button = card.querySelector(".treat-btn");

    if (!button) return;

    button.textContent = `Send ${cat.name} a Treat`;

    // -------------------------
    // Counter
    // -------------------------

    let counter = card.querySelector(".treat-count");

    if (!counter) {

      counter = document.createElement("p");

      counter.className = "treat-count";

      button.parentNode.insertBefore(counter, button);

    }

    counter.textContent =
      `🍗 ${cat.treats_received} treats given`;

    // -------------------------
    // Success message
    // -------------------------

    let success = card.querySelector(".success-message");

    if (!success) {

      success = document.createElement("p");

      success.className = "success-message";

      success.style.opacity = "0";
      success.style.transition = "opacity .35s ease";
      success.style.color = "#2d7d46";
      success.style.fontWeight = "600";
      success.style.marginTop = "16px";

      button.insertAdjacentElement("afterend", success);

    }

  });

  // ----------------------------------
  // Already treated today?
  // ----------------------------------

  const canTreat = await checkDailyTreat();

  if (!canTreat) {

    disableTreatButtons();

  }

});
/* ==========================================
   TREAT BUTTON CLICK
========================================== */

document.addEventListener("click", async (e) => {

  const button = e.target.closest(".treat-btn");

  if (!button) return;

  const card = button.closest(".treat-card");

  if (!card) return;

  e.preventDefault();

  // ----------------------------------
  // Already treated today?
  // ----------------------------------

  const canTreat = await checkDailyTreat();

  if (!canTreat) {

    disableTreatButtons();

    return;

  }

  const catName = card.dataset.catName;

  const cat = cats.get(catName);

  if (!cat) return;

  button.disabled = true;
  button.textContent = "Sending...";

  // ----------------------------------
  // Record today's treat FIRST
  // ----------------------------------

  const sessionId = getBrowserId();

  const { error: eventError } =
    await window.supabaseClient
      .from("cat_treat_events")
      .insert({
        session_id: sessionId,
        cat_id: cat.id
      });

  if (eventError) {

    console.error(eventError);

    button.disabled = false;
    button.textContent = `Send ${cat.name} a Treat`;

    return;

  }

  // ----------------------------------
  // Increment cat treats
  // ----------------------------------

  const { data: updatedCat, error } =
    await window.supabaseClient
      .from("Cats")
      .update({
        treats_received: cat.treats_received + 1
      })
      .eq("id", cat.id)
      .select()
      .single();

  if (error) {

    console.error(error);

    button.disabled = false;
    button.textContent = `Send ${cat.name} a Treat`;

    return;

  }

  // ----------------------------------
  // Update local cache
  // ----------------------------------

  cats.set(updatedCat.name, updatedCat);

  // ----------------------------------
  // Update counter
  // ----------------------------------

  const counter = card.querySelector(".treat-count");

  if (counter) {

    counter.textContent =
      `🍗 ${updatedCat.treats_received} treats given`;

  }

  // ----------------------------------
  // Animation
  // ----------------------------------

  if (typeof playTreatAnimation === "function") {

  playTreatAnimation(button);

}

  // ----------------------------------
  // Success
  // ----------------------------------

  showSuccessMessage(
    card,
    `❤️ ${updatedCat.name} loved that!`
  );

  // ----------------------------------
  // Lock the experience for today
  // ----------------------------------

 disableTreatButtons();

});